var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.651,
    height: 11.741,
    viewBox: "0 0 15.651 11.741",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gmail_5968534_1_",
    "data-name": "gmail_5968534 (1)",
    transform: "translate(0 -63.953)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_978",
    "data-name": "Path 978",
    d: "M1.067,165.985h2.49v-6.047l-1.63-2.847L0,157.27v7.648a1.067,1.067,0,0,0,1.067,1.067Z",
    transform: "translate(0 -90.291)",
    fill: "#0085f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_979",
    "data-name": "Path 979",
    d: "M395.636,165.985h2.49a1.067,1.067,0,0,0,1.067-1.067V157.27l-1.924-.179-1.633,2.847v6.047Z",
    transform: "translate(-383.542 -90.291)",
    fill: "#00a94b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_980",
    "data-name": "Path 980",
    d: "M349.252,65.023l-1.463,2.791,1.463,1.833,3.557-2.668V65.557a1.6,1.6,0,0,0-2.561-1.281Z",
    transform: "translate(-337.158 0)",
    fill: "#ffbc00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_981",
    "data-name": "Path 981",
    d: "M72.165,103.58l-1.394-2.944,1.394-1.68,4.268,3.2,4.268-3.2v4.624l-4.268,3.2Z",
    transform: "translate(-68.608 -33.933)",
    fill: "#ff4131",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_982",
    "data-name": "Path 982",
    d: "M0,65.557V66.98l3.557,2.668V65.023l-1-.747A1.6,1.6,0,0,0,0,65.557Z",
    transform: "translate(0 0)",
    fill: "#e51c19"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.d47f55df9783e27b9cf5a8572c40a56e.svg";
export { ForwardRef as ReactComponent };